<template>
  <div
    class="container"
    v-show="
      route.name !== 'applianceTemplate' && route.name !== 'appliancepersonal'
    "
  >
    <header-menu :title="data.appInfo?data.appInfo.name:''" :tip="data.appInfo?data.appInfo.desc:''" />
    <copywriting
      v-if="data.appInfo &&Number(data.appInfo.creation_type) === 1"
      ref="copywritingRef"
      @clickText="data.editText"
      @editText="data.editText"
      :params="data.appInfo"
      :intro="data.appInfo.intro"
    />
    <imageGeneration
      v-if="data.appInfo && Number(data.appInfo.creation_type) !== 1"
      :params="data.appInfo"
      :intro="data.appInfo.intro"
      @imgEdit="data.imgEdit"
      ref="imageGenerationRef"
    />
    <version
      ref="versionRef"
      @img="data.imgParms"
      @use="data.use"
      @create="data.create"
      @scrollBar="data.scrollBar"
    />
  </div>
  <router-view
    v-show="
      route.name === 'applianceTemplate' || route.name === 'appliancepersonal'
    "
  />
</template>

<script setup>
import {
  ref,
  reactive,
  onBeforeUnmount,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  onActivated,
  computed,
  nextTick,
  onDeactivated,
} from "vue";
import { useCounterStore } from "@/store";
import { getsign } from "@/api/home"
import { useRoute, useRouter } from "vue-router";
import version from "@/components/version";
import headerMenu from "@/components/headerMenu.vue";
import copywriting from "./function/copywriting.vue";
import imageGeneration from "./function/ImageGeneration.vue";
import { getToken } from "@/ulits/auth";
import cross from "@/assets/cross.png";
import { appDeteil } from "@/api/text";
import { showFailToast } from "vant";
/**
 * 仓库
 */
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
store.clearParmas()
const versionRef = ref(null);
const copywritingRef = ref(null);
const imageGenerationRef = ref(null);
const data = reactive({});
data.parmas = {};
data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
if (route.query.id) {
  appDeteil({ app_id: Number(route.query.id) }).then((res) => {
    store.setAppInfo(res.data);
    localStorage.setItem("category_id", res.data.category[0].id);
    localStorage.setItem("appInfo", JSON.stringify(res.data));
    data.appInfo = res.data;
    document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
          "花集AI精灵"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "keywords";
      meta.content =
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
        "花集AI精灵";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", data.appInfo.intro);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = data.appInfo.intro;
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
  });
} else {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
}
data.create = (e) => {
  data.userInfo = localStorage.getItem("userInfo");
  if (getToken() && data.userInfo) {
    copywritingRef.value.AItextClear(e);
  } else {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
    router.push({
      name: "login",
    });
  }
};
data.editText = (e) => {
  if (copywritingRef.value) {
    // copywritingRef.value.writingList = [];
    copywritingRef.value.tutorial = false;
  }
  data.text = "";
  versionRef.value.editText(e);
};

data.scrollBar = (e) => {
  if (copywritingRef.value) {
    copywritingRef.value.tutorial = false;
    copywritingRef.value.setScrollTo();
  }
  if (imageGenerationRef.value) {
    imageGenerationRef.value.tutorial = false;
  }
};

data.imgEdit = (e) => {
  versionRef.value.imgEdit(e);
};

data.imgParms = () => {
  data.userInfo = localStorage.getItem("userInfo");
  if (getToken() && data.userInfo) {
    imageGenerationRef.value.setGenerate();
  } else {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
    router.push({
      name: "login",
    });
  }
};

// 图片
data.use = () => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
  if (Number(data.appInfo.creation_type) === 2) {
    store.setGenerate(false)
  } else {
    store.setGenerate(true)
  }
  if (Number(data.appInfo.creation_type) === 1) {
    copywritingRef.value.writingList = [];
    copywritingRef.value.appInfo = JSON.parse(localStorage.getItem("appInfo"));
    copywritingRef.value.editScenario_case();
    copywritingRef.value.tutorial = true;
    clearInterval(copywritingRef.value.time);
  } else {
    imageGenerationRef.value.list = [];
    imageGenerationRef.value.appInfo = JSON.parse(
      localStorage.getItem("appInfo")
    );
    imageGenerationRef.value.page = 1;
    imageGenerationRef.value.getHistory(2);
  }
  document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "花集AI精灵 " +
        (data.appInfo ? data.appInfo.name : route.meta.keywords) || "花集AI精灵"
    );
  } else {
    const meta = document.createElement("meta");
    meta.name = "keywords";
    meta.content =
      "花集AI精灵 " +
        (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
      "花集AI精灵";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", data.appInfo.intro);
  } else {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = data.appInfo.intro;
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
};

data.getSgin = () =>{
      getsign({url:location.href.split('?')[0]}).then(res=>{
      if (res && res.code === 200) {
         jWeixin.config({
            debug: false, // 调试时可开启
            appId: 'wxf30ed3615020811d', // <!-- replace -->
            timestamp: res.data.timestamp, // 必填，填任意数字即可
            nonceStr: res.data.noncestr, // 必填，填任意非空字符串即可
            signature: res.data.sign, // 必填，填任意非空字符串即可
            jsApiList: ['startRecord','chooseWXPay', 'stopRecord','translateVoice','onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone','updateAppMessageShareData',], // 必填，随意一个接口即可 
         })
      }
   })
   wx.ready(function () { 
    wx.onMenuShareAppMessage({
    title: '花集AI精灵',
    desc: '智慧伴你 随心所欲',
    link: 'https://www.aibene.cn',
    imgUrl: 'https://aibene-resource.huaji.com/png/20231010/202310101603452738.png',
    })
   }); 
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  let u = navigator.userAgent;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (store.WxFlage && store.sginFlag && !isiOS) {
    store.setSginFlag(false)
    data.getSgin()
  }
  if (store.generate) {
    store.copywritingTrue()
  }
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {
if (route.query.id) {
  appDeteil({ app_id: Number(route.query.id) }).then((res) => {
    store.setAppInfo(res.data);
    localStorage.setItem("category_id", res.data.category[0].id);
    localStorage.setItem("appInfo", JSON.stringify(res.data));
    data.appInfo = res.data;
    document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
          "花集AI精灵"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "keywords";
      meta.content =
        "花集AI精灵 " +
          (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
        "花集AI精灵";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", data.appInfo.intro);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = data.appInfo.intro;
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
  });
} else {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
  document.title = route.path === "/appliance"? data.appInfo.name + " — 花集AI精灵" :route.meta.title  + " — 花集AI精灵"
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "花集AI精灵 " +
        (data.appInfo ? data.appInfo.name : route.meta.keywords) || "花集AI精灵"
    );
  } else {
    const meta = document.createElement("meta");
    meta.name = "keywords";
    meta.content =
      "花集AI精灵 " +
        (data.appInfo ? data.appInfo.name : route.meta.keywords) ||
      "花集AI精灵";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", data.appInfo.intro);
  } else {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = data.appInfo.intro;
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
}
});

onBeforeUnmount(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.footer {
  // height: auto; /* 根据内容自适应高度 */
}
::v-deep().laudPopver {
  z-index: 999 !important;
}
::v-deep().tutorial {
  z-index: 66655 !important;
  top: 112px;
  // height: calc( 1114 / 1624 * 100vh);
  padding-bottom: 180px;
  background: #272934;
  overflow-y: hidden;
  overflow-x: hidden;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 44px 44px;
  .header {
    display: flex;
    justify-content: space-evenly;
    position: relative;
    font-size: 32px;
    height: 44px;
    margin: 64px 0 10px 0;
    color: #ffffff;
    .title {
      position: absolute;
      left: 200px;
    }
    .btn {
      color: #8368fcff;
      position: absolute;
      right: 0;
      font-size: 28px;
      display: flex;
      align-items: center;
      img {
        width: 32px;
        height: 32px;
      }
    }
  }
  .intro {
    font-size: 24px;
  }
  .list {
    .swiper-slide {
      width: 80% !important;
      // height: auto;
    }
    .card {
      width: calc(480 / 750 * 100vw);
      height: 300px;
      overflow: hidden;
      overflow-y: auto;
      background: #323647;
      border-radius: 24px;
      padding: 32px;
      .item {
        display: flex;
        // align-items: center;
        .active {
          width: 48px;
          height: 48px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .text {
          flex: 1;
          width: calc(300 / 750 * 100vw);
          overflow: hidden;
          // overflow-y: auto;
          white-space: pre-line;
          word-wrap: break-word;
          font-size: 24px;
          p {
            margin: 0 !important;
          }
        }
        .text::-webkit-scrollbar {
          width: 0 !important;
        }
      }
      .userItem {
        .text {
          overflow: hidden;
          overflow-y: auto;
          white-space: pre-line;
          word-wrap: break-word;
        }
        .text::-webkit-scrollbar {
          width: 0 !important;
        }
      }
      .item:first-child {
        margin-top: 0;
      }
    }
  }
  .bottom {
    position: absolute;
    margin-top: 20px;
    left: 159px;
    display: flex;
    align-items: center;
    color: #f7f5ff;
    font-size: 28px;
    img {
      width: 32px;
      height: 32px;
    }
  }
  .up {
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 32px;
    left: calc(50% - 48px);
  }
}
::v-deep().imgPopup {
  z-index: 2111 !important;
  top: 112px;
  // height: calc( 1114 / 1624 * 100vh);
  padding-bottom: 180px;
  background: #272934;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 44px 44px;
  .item {
    margin-top: 40px;
    display: flex;
    padding: 0 24px;
    .active {
      img {
        width: 88px;
        height: 88px;
      }
      border-radius: 88px;
    }
    .text {
      align-self: flex-start;
      background: #323647;
      padding: 20px;
      width: calc(580 / 750 * 100vw);
      color: #ffffffff;
      font-size: 28px;
      font-weight: 300;
      border-radius: 24px;
      text-align: justify;
      margin-left: 16px;
      white-space: pre-line;
      word-wrap: break-word;
    }
  }
  .header {
    display: flex;
    justify-content: space-evenly;
    position: relative;
    font-size: 32px;
    height: 44px;
    margin: 64px 0 10px 0;
    color: #ffffff;
    .title {
      position: absolute;
      left: 200px;
    }
    .btn {
      color: #8368fcff;
      position: absolute;
      right: 0;
      font-size: 28px;
      display: flex;
      align-items: center;
      img {
        width: 32px;
        height: 32px;
      }
    }
  }
  .list {
    display: flex;
    overflow: hidden;
    overflow-x: auto;

    .card {
      margin-right: 32px;
      img {
        width: 400px;
        height: 400px;
      }
    }
  }
  .list::-webkit-scrollbar {
    display: none;
  }
  .cardBtn {
    position: absolute;
    margin-top: 20px;
    left: 159px;
    display: flex;
    align-items: center;
    color: #f7f5ff;
    font-size: 28px;
  }
  .up {
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 32px;
    left: calc(50% - 48px);
  }
}
::v-deep().yuyin {
  overflow: hidden;
  z-index: 66655 !important;
  height: 452px;
  background: #111525;
  border-radius: 48px 48px 0px 0px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  .main {
    text-align: center;
    .header {
      margin-top: 50px;
      color: #ffffff;
      font-size: 32px;
      text-align: center;
    }
    .close {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 40px;
      right: 30px;
      cursor: pointer;
    }
    .time {
      font-size: 48px;
      color: #ffffff;
      text-align: center;
      margin-top: 24px;
      font-family: DINAlternate-Bold, DINAlternate;
    }
    .text {
      margin-top: 28px;
      color: #ffffff;
      font-size: 28px;
    }
  }
}

::v-deep().sharesPopup {
  background: transparent !important;
}

::v-deep().setPop {
  padding-bottom:180px;
  border-radius: 48px 48px 0px 0px;
  .popCloseClass {
    position: absolute;
    top: 0;
    right: 32px;
    width: 48px;
    height: 48px;
  }
  .header {
    position: relative;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 34px;
    color: #222222;
  }
  .tip {
    margin-top: 20px;
    font-size: 32px;
    color: #222222;
    text-align: center;
    margin-bottom: 33px;
    span {
      font-size: 28px;
      color: #666666;
    }
  }
  .acquiesce {
    display: flex;
    align-items: center;
    padding-left: 32px;
    margin-bottom: 32px;
  }
  .van-radio {
    margin-bottom: 20px;
    padding-left: 32px;
    .van-radio__icon {
      height: 52px;
    }
    .van-radio__label {
      height: 52px;
      line-height: 52px;
      display: flex;
      align-items: center;
    }
  }
  .van-tab__text--ellipsis {
    height: 100%;
  }
  .vip {
    width: 88px;
    height: 36px;
    background: linear-gradient(119deg, #fddb9e 0%, #e3b15b 100%);
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 24px;
    color: #291d0fff;
    font-size: 30px;
    text-align: center;
    line-height: 36px;
  }
  .img-icon {
    width: 44px;
    height: 44px;
  }
  .desc {
    padding: 0 32px;
    .input {
      // margin-top: 12px;
      min-height: 135px;
      background: #eeeeee;
      border-radius: 18px;
      position: relative;
      padding-bottom: 45px;
      .van-cell-group--inset {
        margin: 0;
        border-radius: 35px;
        background: #eeeeee;
      }
      .van-cell {
        background: #eeeeee;
        margin-top: 10px;
      }
      .van-field__control {
        color: #000000 !important;
        padding-top: 10px;
        line-height: 1 !important;
      }
      .sort {
        position: absolute;
        bottom: 20px;
        right: 20px;
        display: flex;
        font-size: 28px;
        align-items: center;
        color: #ccccccff;
        img {
          margin-left: 12px;
          width: 36px;
          height: 36px;
        }
      }
    }
  }
  .imgList {
    margin-top: 40px;
    padding: 0 32px;
    .itemList {
      display: flex;
      .item {
      position: relative;
        .van-icon {
          position: absolute;
          right: 30px;
          border-radius: 0 0 0 50%;
          background: #66666630;
        }
      }
      img {
        width: 160px;
        height: 160px;
        margin-right: 30px;
      }

    }
    .title {
      margin-bottom: 12px;
    }
    .uploaderClass {
      width: 162px;
      height: 162px;
    }
    .van-uploader {
      width: 100%;
    }
    .van-uploader__wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .van-uploader__preview {
      width: 160px;
      height: 160px;
    }
    .van-uploader__preview-delete {
      width: 20px;
      height: 20px;
      .van-icon-cross {
        font-size: 20px;
      }
    }
    .van-image {
      width: 160px;
      height: 160px;
      border-radius: 16px;
      img {
        width: 160px;
        height: 160px;
        border-radius: 16px;
      }
    }
  }
  .styleList {
    padding: 0 24px;
    margin-top: 16px;
    color: #666666ff;
    font-size: 30px;
    .tabs {
    display: flex;
    white-space: nowrap; 
    overflow-y: auto;
    padding-bottom: 10px;
      .item {
        margin-right: 48px;
      }
    }
    .tabs::-webkit-scrollbar {
      display: none;
    }
    .tabsName {
      position: relative;
    }
    .quitTabsName {
      color: #222222;
      font-weight: 500;
      position: relative;
    }
    .quitTabsName::after {
      content: "";
      background: #8368fc;
      border-radius: 30px;
      height: 4px;
      width: calc(100% - 20px);
      margin: 0 10px;
      left: 0;
      position: absolute;
      bottom: -5px;
    }
    .gar8 {
      grid-auto-rows: 80px !important;
      grid-gap: 48px !important;
    }
    .iosClass {
      height: calc(100vh - 1030px) !important;
    }
    .tabsCenten {
      height: calc(100vh - 970px);
      overflow: hidden;
      overflow-y: auto;
      margin-top: 24px;
      display: grid;
      grid-auto-rows: 160px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 24px;
      .quitStyleClass {
        color: #ffffff !important;
        border: 4px solid #8368fc;
        box-sizing: border-box;
        background: #8368fc !important;
        .quitBoxClass {
          border-color: #ffffff !important;
        }
      }
      .item {
        .scalingItemClass {
          border: 2px solid #8368fcff;
          background: transparent;
          color: #8368fc;
          border-radius: 40px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          .box {
            margin-right: 10px;
            border: 4px solid #8368fcff;
          }
        }
      }
      .StyleItemClass {
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 16px;
        }
        .itemName {
          position: absolute;
          bottom: 7px;
          width: 100%;
          background: #11152540;
          color: #f7f5ff;
          font-size: 24px;
          text-align: center;
          padding: 7px 0;
          border-radius: 0px 0px 16px 16px;
        }
      }
    }
    .tabsCenten::-webkit-scrollbar {
      display: none;
    }
  }
  .clearBtn {
    box-shadow: 0px 0px 35px 0px rgba(0,0,0,0.1);
    background: #ffffff;
    position: fixed;
    padding-bottom: 70px;
    bottom: 0px;
    left: 0;
    width: 100%;
    .btn {
      font-size: 32px;
      margin: 0 75px;
      padding: 21px 0;
      margin-top: 20px;
      background: #8368fc;
      border-radius: 49px;
      text-align: center;
      color:#ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 24px;
      }
    }
  }
}

::v-deep().sharesPopup::-webkit-scrollbar {
  display: none;
}
::v-deep().acitvePopup {
  z-index: 66655 !important;
  .close {
    position: absolute;
    right: 32px;
    top: 40px;
    cursor: pointer;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .header {
    font-size: 34px;
    color: #222222;
    font-weight: 500;
    text-align: center;
    margin-top: 40px;
  }
  .tip {
    margin-top: 20px;
    font-size: 32px;
    color: #222222;
    text-align: center;
    margin-bottom: 33px;
    span {
      font-size: 28px;
      color: #666666;
    }
  }
  .acquiesce {
    display: flex;
    align-items: center;
    padding-left: 32px;
    margin-bottom: 32px;
  }
  .van-radio {
    margin-bottom: 20px;
    padding-left: 32px;
    .van-radio__icon {
      height: 52px;
    }
    .van-radio__label {
      height: 52px;
      line-height: 52px;
      display: flex;
      align-items: center;
    }
  }
  .van-tab__text--ellipsis {
    height: 100%;
  }
  .vip {
    width: 88px;
    height: 36px;
    background: linear-gradient(119deg, #fddb9e 0%, #e3b15b 100%);
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 24px;
    color: #291d0fff;
    font-size: 30px;
    text-align: center;
    line-height: 36px;
  }
  .img-icon {
    width: 44px;
    height: 44px;
  }
  .scaling {
    margin-top: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 44px;
    justify-items: center;
    .card {
      width: 188px;
      height: 80px;
      display: flex;
      align-items: center;
      border-radius: 39px;
      justify-content: center;
      border: 4px solid #8368fc;
      .text {
        color: #8368fcff;
        font-family: DINAlternate-Bold, DINAlternate;
        font-size: 32px;
        font-weight: bold;
        margin-left: 8px;
      }
    }
  }
}
</style>
